import { useQuery } from '@tanstack/react-query';
import { getAccountRiskDetails } from '../../api';
import CowbellFactorsMapping from '../../utility/CowbellFactorsMapping';
import { manageAPIError } from '../../utils';
import useNotifications from '../../_lib/notifications/useNotifications';

export const useGetCustomerRiskFactors = ({ accountId }: any) => {
  const notifications = useNotifications();

  const query = useQuery(
    ['customer-risk-details', accountId],
    () => {
      return getAccountRiskDetails(accountId).then(({ data }: any) => data);
    },
    {
      enabled: !!accountId,
      onError: (error: any) => {
        notifications.error(
          manageAPIError(error, 'Unable to retrieve risk data at this time.')
        );
      },
      refetchOnWindowFocus: false,
    }
  );

  const cowbellFactorsRiskData = getCowbellFactorsRiskData(
    query?.data?.details
  );

  return { query, cowbellFactorsRiskData }; // since hook is re-usable, I want to preserve the cache, and leave it un-altered
};

const getCowbellFactorsRiskData = (riskData: any) => {
  if (riskData) {
    const cowbellFactorsRiskData = Object.keys(CowbellFactorsMapping)
      .filter(
        (factor) =>
          factor !== excludedFactors.INSIDER_THREAT && Boolean(riskData[factor])
      )
      .map((riskFactor) => {
        return {
          label: CowbellFactorsMapping[riskFactor].label,
          tooltip: CowbellFactorsMapping[riskFactor].tooltip,
          key: riskFactor,
          ...riskData[riskFactor],
        };
      });

    return cowbellFactorsRiskData;
  }
  return []; // fallback to empty array
};

const excludedFactors = {
  INSIDER_THREAT: 'insiderThreat',
};
